import { Record } from 'immutable';

import CampaignRecord from 'records/campaign';
import PromotionRecord from 'records/promotion';

export default Record({
    campaign: CampaignRecord(),
    campaignId: null,
    companyId: null,
    confirmationCode: null,
    confirmed: 0,
    createdAt: '',
    email: '',
    id: null,
    ip: '',
    name: '',
    promotion: PromotionRecord(),
    promotionId: null,
    reason: '',
    status: null,
});



// WEBPACK FOOTER //
// ./src/records/order.js